<template>
  <div class="page_wrapper container-fluid enterprise_visit_area">
    <div class="row page_header enterprise_visit_header">
      <enterprise-visit-header />
    </div>
    <div class="row enterprise_visit_content">
      <enterprise-visit-index-content />
    </div>
  </div>
</template>
<script>
import EnterpriseVisitHeader from '~components/pages/enterprise-visits/EnterpriseVisitHeader'
import EnterpriseVisitIndexContent from '~components/pages/enterprise-visits/EnterpriseVisitIndexContent'
import '~style/pages/enterprise_visit.scss'
export default {
  name: 'EnterpriseVisitIndex',
  routerName: 'Enterprise-visits',
  components: {
    EnterpriseVisitHeader,
    EnterpriseVisitIndexContent
  }
}
</script>
